import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CustomToastContainer = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover={false}
      theme="light"
      style={{
        zIndex: 99999
      }}
      toastStyle={{
        backdropFilter: 'blur(10px)',
        background: 'rgba(255, 255, 255, 0.95)',
        color: '#333',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
      }}
      progressStyle={{
        background: 'linear-gradient(135deg, #0ea5e9 0%, #d946ef 100%)'
      }}
      closeButtonStyle={{
        color: '#666',
        opacity: 0.7
      }}
    />
  );
};

export default CustomToastContainer;
